import { createContext, useContext } from "react";

export const NodeActionsContext = createContext({
  onDeleteNode: () => {},
  onDuplicateNode: () => {},
  onDeleteEdge: () => {},
});

export const useNodeActions = () => useContext(NodeActionsContext);
